import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { SeenHoverLink } from './SeenHoverLink';

export interface SeenWithoutCountTextProps {
  color?: string;
}

export function SeenWithoutCountText({ color = Colors.v2.gray30 }: SeenWithoutCountTextProps) {
  return <SeenHoverLink content={i18n('chat.seen')} color={color} />;
}
